import Schedules from "views/components/Schedules/Schedules";
import ScheduleActivity from "./components/ScheduleActivity/ScheduleActivity";
import { isPastSchedule } from "utils/date";
import { HOUR_IN_MINUTES } from "utils/time";

const SchedulesWrapper = ({
    data, date,
    reloadData, isAdviser,
    nextOrBackReservationPage,
    takeWeek,
    isBoss
}) => {
    const renderActivity = ({
        cell: { time, item, idx },
        helpers: { renderEmptyActivity }
    }) => {
        const emptyActivityColor = idx % 2 === 0 ? "light" : "gray";
        const isHourOclock = time.minutes === 0;
        if (!item) {
            // Renderizando vacío
            return isHourOclock && renderEmptyActivity(idx, emptyActivityColor);
        }
        if (!isHourOclock) return null;
        const {
            adviser, appointments,
            filteringByStudent
        } = item;
        for (const appointment of appointments) {
            const {
                schedule, reservations,
                inactivities
            } = appointment;
            const { date: dateSchedule } = schedule;
            const currentMinutes = time.totalMinutes;
            // Buscando actividad
            const foundReservation = reservations.find(({ timeStart }) => timeStart === currentMinutes);
            if (foundReservation) {
                const {
                    student, attended,
                    id: reservationId,
                    phone, comment, quantity,
                    zoom
                } = foundReservation;
                const { isPresential, place } = schedule;
                //#region Gestión de clases
                const classList = [];
                isPresential && classList.push("presential");
                const isPast = isPastSchedule({
                    date: takeWeek ? dateSchedule : date,
                    minutes: foundReservation.timeStart + HOUR_IN_MINUTES
                });
                isPast && classList.push("past");
                //#endregion
                return (
                    <ScheduleActivity
                        key={idx}
                        title={student.name}
                        subtitle={student.id}
                        classList={classList}
                        isAdviser={isAdviser}
                        isPast={isPast}
                        filteringByStudent={filteringByStudent}
                        footerData={{
                            place, zoom
                        }}
                        dateTimeData={{
                            hour: time.hour,
                            date: dateSchedule
                        }}
                        reservation={{
                            id: reservationId,
                            phone, comment,
                            attended, quantity
                        }}
                        appointmentId={schedule.appointmentId}
                        isPresential={isPresential}
                        nextOrBackReservationPage={nextOrBackReservationPage}
                        reloadData={reloadData}
                        isBoss={isBoss} />
                );
            }
            if (filteringByStudent)
                continue;
            const isPast = isPastSchedule({
                date: takeWeek ? dateSchedule : date,
                minutes: time.totalMinutes
            });
            // Buscando inactividad
            const foundInactivity = inactivities.find(({ start, end }) => {
                return currentMinutes >= start && currentMinutes < end;
            });
            if (foundInactivity) {
                //#region Gestión de clases
                const classList = ["inactivity"];
                isPast && classList.push("past");
                isAdviser && classList.push("adviser");
                //#endregion
                return (
                    <ScheduleActivity
                        key={idx}
                        title="Otras Actividades"
                        classList={classList}
                        dateTimeData={{
                            hour: time.hour,
                            date: dateSchedule
                        }}
                        adviser={adviser}
                        isAdviser={isAdviser}
                        inactivity={foundInactivity}
                        reloadData={reloadData}
                        isBoss={isBoss} />
                );
            }
            // Buscando turno disponible
            if (currentMinutes >= schedule.start &&
                currentMinutes < schedule.end) {
                const { isPresential, durationId } = schedule;
                //#region Gestión de clases
                const classList = ["available"];
                isPast && classList.push("past");
                isPresential && classList.push("presential");
                isAdviser && classList.push("adviser");
                //#endregion
                return (
                    <ScheduleActivity
                        key={idx}
                        title="Turno Disponible"
                        classList={classList}
                        isPast={isPast}
                        adviser={adviser}
                        isAdviser={isAdviser}
                        dateTimeData={{
                            durationId,
                            hour: time.hour,
                            date: dateSchedule
                        }}
                        reloadData={reloadData}
                        isBoss={isBoss} />
                );
            }
        }
        // Renderizando vacío 
        if (!isHourOclock) return null;
        return renderEmptyActivity(idx, emptyActivityColor);
    }
    return (
        <Schedules
            data={data} filterDate={date}
            renderActivity={renderActivity}
            takeWeek={takeWeek} />
    );
}

export default SchedulesWrapper;